import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    booksData: [],
    links: null,
    totalProducts: 0,
    showingProducts: 0,
    isLoading: false,
};

const booksSlice = createSlice({
    name: "books",
    initialState,
    reducers: {
        setBooks: (state, action) => {
            state.booksData = action.payload.booksData;
            state.links = action.payload.links;
            state.totalProducts = action.payload.totalProducts;
            state.showingProducts = action.payload.showingProducts;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    },
});

export const { setBooks, setLoading } = booksSlice.actions;
export default booksSlice.reducer;
